import React, { useMemo } from 'react'

import { useSearchParams } from 'react-router-dom'

import { useTranslation } from '@/core/i18n/useTranslation'
import PageLayout from '@/shared/components/organisms/Layout/PageLayout'

import { ZoneNavigationSidebar } from './components/ZoneNavigationSidebar'

interface ZoneDetailsLayoutProps {
	activeTab: string
	onTabChange: (tab: string) => void
	children: React.ReactNode
	headerActions?: React.ReactNode
	titleActions?: React.ReactNode
}

export const ZoneDetailsLayout: React.FC<ZoneDetailsLayoutProps> = ({
	activeTab,
	onTabChange,
	children,
	headerActions,
	titleActions,
}) => {
	const { t } = useTranslation('common')
	const [searchParams] = useSearchParams()

	// Check the 'from' query parameter to determine where to go back
	const backPath = useMemo(() => {
		const from = searchParams.get('from')
		if (from === 'subscription') {
			return '/account?tab=subscription'
		}
		return '/zones'
	}, [searchParams])

	return (
		<PageLayout
			backButton={{ show: true, to: backPath }}
			title={t('entities.zone.details.title')}
			contentClassName="p-0"
			showSeparator={true}
			headerActions={headerActions}
			titleActions={titleActions}
		>
			<div className="flex flex-col lg:flex-row">
				<div className="hidden lg:block px-6 py-6">
					<ZoneNavigationSidebar
						activeTab={activeTab}
						onTabChange={onTabChange}
					/>
				</div>

				<div className="flex-1 px-4 py-4 lg:px-8 lg:py-6 min-h-[calc(100vh-300px)]">
					{children}
				</div>
			</div>
		</PageLayout>
	)
}
